module.exports = __webpack_public_path__ + "static/media/allow-access-mobile.57c883c1.png";